/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
      this.page_size = this.dataset.pageSize;
      /* ZUMO custom: total page count (data-pages), used to guard the page-size hide below */
      this.pages = parseInt(this.dataset.pages, 10) || 0;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      const appendProducts = () => {
        /* ZUMO perf: product-card.liquid emits the (display:none) .product-secondary-image hover
           images BEFORE the visible primary image, so a single pass asked the browser for up to 3
           invisible images per card before the one image the shopper actually sees - and the grid
           paginates by 200 (main-collection-product-grid.liquid:58). Unveil the visible images
           first and let the hover images follow on idle. Every image is still unveiled, and
           app.js's product-card unveils a card's hover images immediately on hover/touch, so
           hovering an appended card is never slower than before. requestIdleCallback has a 2s
           timeout (setTimeout fallback) so the pass always runs. */
        const hover_images = [];
        products.forEach((product) => {
          this.grid.appendChild(product);
          product.querySelectorAll('.lazyload').forEach((image) => {
            if (image.classList.contains('product-secondary-image')) {
              hover_images.push(image);
              return;
            }
            lazySizes.loader.unveil(image);
          });
        });
        if (hover_images.length) {
          const unveilHoverImages = () => {
            hover_images.forEach((image) => {
              /* ZUMO perf: skip cards a facet filter tore out while the callback was pending */
              if (image.isConnected) {
                lazySizes.loader.unveil(image);
              }
            });
          };
          if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(unveilHoverImages, { timeout: 2000 });
          } else {
            setTimeout(unveilHoverImages, 500);
          }
        }
      };

      if (this.animations_enabled) {
        // GSAP staggers the new items in — a view transition on top
        // would snapshot them pre-animation and flicker. Append directly.
        appendProducts();
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
          }
        });
      } else {
        withViewTransition(appendProducts);
        base.removeAttribute('loading');
        /* ZUMO custom: guard the vanilla-17 StampedFn reference. `typeof StampedFn.loadBadges`
           still evaluates StampedFn and throws a ReferenceError when no Stamped.io script is on
           the page, which aborts the rest of load() — including the ZUMO hide() check below. */
        if (typeof StampedFn !== 'undefined' && typeof StampedFn.loadBadges !== 'undefined') {
          StampedFn.loadBadges();
        }
      }
      /* ZUMO custom: main-collection-product-grid only renders available products with a
         featured image, so a page can hold fewer than page_size items while more pages follow.
         Only hide once the last page has been fetched (this.i is already the next page number). */
      if (products.length < this.page_size && !(this.pages && this.i <= this.pages)) {
        this.hide();
      }
    }
    hide() {
      this.button.style.display = 'none';
    }
  }
  customElements.define('pagination-theme', Pagination);
}